import { Component, computed, inject, signal } from "@angular/core";
import { ParameterService, PaymentService } from "../../provider";
import { SpinnerComponent } from "../spinner/spinner.component";

@Component({
    selector: 'lib-frontend-amazonpay-autorize-capture',
    templateUrl: 'amazonpay-autorize-capture.html',
    standalone: true,
    imports: [SpinnerComponent]
})
export class AmazonpayAutorizeCapture
{

    loading = signal(false);
    private paymentService = inject(PaymentService);
    public parameterService = inject(ParameterService);
    url = signal<string | undefined>('');

    showAmazonRedirect = signal(false);

    public backUrl = computed(() => this.parameterService.getOverviewUrl());

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.loading.set(true);
        this.paymentService.setAmazonAuthorizationWithCapture(
            this.parameterService.queryParams.channel_id, 
            this.parameterService.queryParams.payment_id ?? '',
            this.parameterService.getAllQueryParameterWithOrigin()
        ).subscribe(val => {
            this.url.set(val.data)
            this.loading.set(false);
            if (this.url())
            {
                setTimeout(() => {
                    window.location.assign(this.url() ?? '');
                }, 1000);
                setTimeout(() => {
                    this.showAmazonRedirect.set(true);
                }, 5000);
            }
        });
    }

}